import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/splide/css";

export const opinionSlider = (sliderElement: HTMLElement): Splide => {
    const slider = new Splide(sliderElement, {
        type: "loop",
        perPage: 1,
        autoplay: true,
        pagination: false,
        interval: 5000,
        speed: 1500,
        gap: 70,
        updateOnMove: true,
        easing: "ease-in-out",
    }).mount();

    return slider;
};

export const servicesSlider = (sliderElement: HTMLElement): Splide => {
    const slider = new Splide(sliderElement, {
        type: "fade",
        perPage: 1,
        updateOnMove: true,
        rewind: true,
        speed: 700,
        pagination: false,
    }).mount();

    return slider;
};

export const boxesSlider = (sliderElement: HTMLElement): Splide => {
    const slider = new Splide(sliderElement, {
        type: "loop",
        focus: "center",
        pagination: false,
        perPage: 2,
        perMove: 1,
        rewind: true,
        speed: 1000,
        updateOnMove: true,
        easing: "ease-in-out",
        gap: "32px",
        breakpoints: {
            1024: {
                perPage: 1,
                speed: 500,
            },
        },
    }).mount();

    return slider;
};

export const workersSlider = (sliderElement: HTMLElement): Splide => {
    const slider = new Splide(sliderElement, {
        focus: "center",
        perPage: 1,
        perMove: 1,
        rewind: true,
        speed: 1000,
        easing: "ease-in-out",
        gap: "64px",
        pagination: false,
    }).mount();

    return slider;
};

export const clientsLogoSlider = (sliderElement: HTMLElement): Splide => {
    const slider = new Splide(sliderElement, {
        focus: "center",
        perPage: 3,
        perMove: 1,
        rewind: true,
        speed: 500,
        easing: "ease-in-out",
        updateOnMove: true,
        gap: "16px",
        pagination: false,
        breakpoints: {
            1024: {
                perPage: 2,
                gap: 0,
            },

            800: {
                perPage: 1,
            },
        },
    }).mount();

    return slider;
};

export const tagsSlider = (sliderElement: HTMLElement, countOfSlides: number | boolean): Splide => {
    const actLikeSlider = (count: number): boolean => {
        if (!countOfSlides) return true;

        if (typeof countOfSlides === "number") {
            return count < countOfSlides ? true : false;
        }
        return false;
    };

    const slider = new Splide(sliderElement, {
        perPage: 6,
        perMove: 1,
        rewind: true,
        speed: 500,
        easing: "ease-in-out",
        updateOnMove: true,
        pagination: false,
        gap: "32px",
        arrows: actLikeSlider(6),
        drag: actLikeSlider(6),
        breakpoints: {
            1710: {
                perPage: 5,
                arrows: actLikeSlider(4),
                drag: actLikeSlider(4),
            },
            1280: {
                perPage: 4,
                arrows: actLikeSlider(3),
                drag: actLikeSlider(3),
            },
            1024: {
                perPage: 3,
                arrows: actLikeSlider(2),
                drag: actLikeSlider(2),
            },
            800: {
                perPage: 2,
                arrows: actLikeSlider(1),
                drag: actLikeSlider(1),
            },
            580: {
                perPage: 1,
                arrows: true,
                gap: "24px",
            },
        },
    }).mount();

    return slider;
};

export const technologiesLogoSlider = (sliderElement: HTMLElement) => {
    const slider = new Splide(sliderElement, {
        type: "loop",
        perPage: 7,
        arrows: false,
        pagination: false,
        gap: 48,
        lazyLoad: "nearby",
        fixedHeight: 48,
        autoWidth: true,
    }).mount({ AutoScroll });

    return slider;
};
